<template>
<div>
    <router-view></router-view>
</div>
</template>

<script>
import Vue from 'vue'

import elg from '../api/elg.gateway.js' 
import store from '../store/index.js'

import Login from './Login'

Vue.component('Login', Login);

export default {
  data() {
    return {
      interval: undefined
    }
  },
  methods: {
    ping: function(){
      return elg().get('/api/v1/server/ping')
      .then( res => {

      });
    }
  },
  mounted: function(){
    this.interval = setInterval( () => {
      if(store.state.isLoggedIn){
        this.ping();
      }
    }, 10000);
  },
  beforeDestroy: function(){
    clearInterval(this.interval);
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// WebApp/components/app-root.vue